module.exports = __webpack_public_path__ + "static/assets/52ac58d8ef4e53d6449e592b68359d46.mp3";